function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#newspaper_svg__clip0_237_20268)",
  fill: "#B6B6B6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.969 4.512H6.995a.634.634 0 100 1.268h3.974a.634.634 0 100-1.268zM12.49 7.578H6.996a.634.634 0 100 1.268h5.496a.634.634 0 100-1.268z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.366.54H4.143a.634.634 0 00-.634.633v5.982h-1.12A2.391 2.391 0 000 9.543v3.53a2.391 2.391 0 002.706 2.367h10.462A2.836 2.836 0 0016 12.608V1.173a.634.634 0 00-.634-.634zM3.509 13.072c0 .543-.39.998-.904 1.099h-.217v.02c-.617 0-1.12-.502-1.12-1.12V9.544c0-.618.503-1.12 1.12-1.12h1.12v4.65zm11.223-.465c0 .848-.716 1.564-1.564 1.564h-8.66c.172-.33.269-.703.269-1.1V1.808h9.955v10.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.969 10.453H6.995a.634.634 0 100 1.268h3.974a.634.634 0 100-1.268z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "newspaper_svg__clip0_237_20268"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));

function SvgNewspaper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgNewspaper;